/** @format */

import React, { ReactNode } from "react";
import styled from "styled-components";
import { colors, mixins } from "../../../../css/variables";
import { BcartEntryContentsMerchant } from "./EntryContents/EntryContentsMerchant";
import { BcartEntryContentsBankAccount } from "./EntryContents/EntryContentsBankAccount";
import { BcartEntryContentsShop } from "./EntryContents/EntryContentsShop";
import { BcartEntrySide } from "./EntrySide";

const EntryColumnStyle = styled.div`
  display: flex;
  ${mixins.screenOver()} {
    gap: 32px;
  }
  ${mixins.screenUnder()} {
    flex-direction: column;
  }
  & > main {
    flex: 1;
    background: ${colors.themeColor("background_main")};
    border-radius: 8px;
    border: 1px solid ${colors.themeColor("border_box")};
    ${mixins.screenOver()} {
      padding: 36px;
    }
    ${mixins.screenUnder()} {
      padding: 28px 16px;
    }
  }
  & > div:last-child {
    ${mixins.screenOver()} {
      width: 270px;
    }
  }
`;

export const BcartEntryColumn = ({ path, redirect = false }: { path: string; redirect?: boolean }) => {
  let showPage: ReactNode = <></>;
  switch (path) {
    case "merchant":
      showPage = <BcartEntryContentsMerchant />;
      break;
    case "bank_account":
      showPage = <BcartEntryContentsBankAccount />;
      break;
    case "shop":
      showPage = <BcartEntryContentsShop />;
      break;
    default:
      showPage = "表示する内容がありません";
  }
  return (
    <EntryColumnStyle>
      <main>{showPage}</main>
      <div>
        <BcartEntrySide path={path} redirect={redirect} />
      </div>
    </EntryColumnStyle>
  );
};
